module.exports = __webpack_public_path__ + "static/img/case_logo_14.e363bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_logo_14.png
// module id = zSPF
// module chunks = 34